import request from '@/utils/request'

// const baseUrlSimpleClassZhihuishu = 'https://simple-class.zhihuishu.com/simple-class'
const baseUrlSimpleClassZhihuishu = 'https://zhs-simple-class.zhihuishu.com/simple-class'

const getBigRoomSocketInfo = (params) => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: '/admin/screen/getBigRoomSocketInfo',
    method: 'get',
    params
  })
}

// 获取数据大屏初始化数值
const getPanoramaClassroomCodeList = (params) => {
  return request({
    url: '/admin/screen/getPanoramaClassroomCode',
    method: 'post',
    params
  })
}

// 获取数据大屏初始化数值
const initEachScreenData = (params) => {
  return request({
    url: '/admin/screen/getInitData',
    method: 'get',
    params
  })
}

/* 
    楼栋号下拉列表筛选项
    panoramaClassroomCode 全景教室编号
*/
const getFilterOptions = (params) => {
  return request({
    url: '/admin/screen/filterOptions',
    method: 'post',
    params
  })
}

/* 
    全景教室大屏重选直播列表
    schoolCode 学校ID
    panoramaClassroomCode 全景教室编号
    filterType 筛选类型
    filterOptions 下拉筛选项 array<string>
*/
const getReselectLiveList = (params) => {
  return request({
    url: '/admin/screen/liveList',
    method: 'get',
    params
  })
}

// 全景教室大屏重选
const reselectLive = (params) => {
  return request({
    url: '/admin/screen/reselect',
    method: 'post',
    params
  })
}

// 课程下课后获取一个课
const getOneNewClass = (params) => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: '/admin/screen/getNextLive',
    method: 'post',
    params
  })
}

// 切换楼栋
const changeBuilding = (params) => {
  return request({
    url: '/admin/screen/switchBuilding',
    method: 'post',
    params
  })
}
// 换一批课程
const getNextBatchClass = (params) => {
  return request({
    url: '/admin/screen/changeData',
    method: 'post',
    params
  })
}
// 下课后获取哪个屏幕的课下了
const getEndclassInfo = (params) => {
  return request({
    url: 'admin/screen/getScreenInfo',
    method: 'get',
    params
  })
}

/**
 * @description: web大屏直播列表
 * @param {*} params
 * @return {*}
 */
const getWebScreenData = (params) => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: '/admin/screen/getWebScreenData',
    method: 'get',
    params
  })
}

/**
 * @description: ipad切屏幕接口
 * @param {*} params
 * @return {*}
 */
const screenSelectChange = (params) => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: '/admin/screen/select/change',
    method: 'post',
    params
  })
}

/**
 * @description: 教学楼数据统计
 * @param {*} params
 * @return {*}
 */
const screenSchoolBuildingStatistics = () => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: '/admin/screen/schoolBuildingStatistics',
    method: 'get'
  })
}

export default {
  getBigRoomSocketInfo,
  getPanoramaClassroomCodeList,
  initEachScreenData,
  getFilterOptions,
  getReselectLiveList,
  reselectLive,
  getOneNewClass,
  changeBuilding,
  getNextBatchClass,
  getEndclassInfo,
  getWebScreenData,
  screenSelectChange,
  screenSchoolBuildingStatistics
}
